import { StyleSheet } from 'aphrodite';
import { THEME } from '@HoudiniUI/Theme/theme';

const inputFieldWidth = 300;
// Aligns the section under the Profile card's value column (matches the 200px `formFieldLabel` width).
const labelColumnWidth = 200;
// The help box and each mailbox row share this width so the row actions align with the box edge.
const sectionContentWidth = 520;

export const styleSheet = StyleSheet.create({
	container: {
		marginBottom: THEME.spacing.md,
		marginLeft: labelColumnWidth,
	},
	sectionHeader: {
		color: THEME.colors.text.main,
		fontSize: THEME.typography.fontSizes.sm,
		fontWeight: THEME.typography.fontWeights.bold,
		marginBottom: THEME.spacing.xs,
	},
	mailboxRow: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.sm,
		maxWidth: sectionContentWidth,
	},
	rowSummary: {
		alignItems: 'center',
		display: 'flex',
		flexWrap: 'wrap',
		gap: THEME.spacing.md,
	},
	rowIdentity: {
		display: 'flex',
		flexDirection: 'column',
		gap: 2,
		minWidth: 200,
	},
	rowName: {
		color: THEME.colors.text.main,
		fontSize: THEME.typography.fontSizes.sm,
		fontWeight: THEME.typography.fontWeights.semibold,
	},
	rowAddress: {
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.xs,
	},
	rowBadge: {
		fontSize: THEME.typography.fontSizes.xs,
		whiteSpace: 'nowrap',
	},
	rowBadgeWarning: {
		color: THEME.colors.warning.main,
	},
	rowActions: {
		alignItems: 'center',
		display: 'flex',
		gap: THEME.spacing.xs,
		marginLeft: 'auto',
	},
	srOnly: {
		border: 0,
		clip: 'rect(0 0 0 0)',
		height: 1,
		margin: -1,
		overflow: 'hidden',
		padding: 0,
		position: 'absolute',
		whiteSpace: 'nowrap',
		width: 1,
	},
	addRow: {
		alignItems: 'center',
		display: 'flex',
		flexWrap: 'wrap',
		gap: THEME.spacing.sm,
	},
	addHint: {
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.xs,
	},
	fields: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.md,
		marginTop: THEME.spacing.md,
	},
	field: {
		width: inputFieldWidth,
	},
	inputControl: {
		width: '100%',
	},
	fieldLabel: {
		color: THEME.colors.text.light,
		display: 'block',
		fontSize: THEME.typography.fontSizes.xs,
		marginBottom: THEME.spacing.xs,
	},
	validationError: {
		color: THEME.colors.danger.main,
		fontSize: THEME.typography.fontSizes.xs,
		marginTop: THEME.spacing.xs,
	},
	actions: {
		display: 'flex',
		gap: THEME.spacing.sm,
		marginTop: THEME.spacing.sm,
	},
	actionButton: {
		whiteSpace: 'nowrap',
	},
	reconnectBanner: {
		alignItems: 'center',
		background: THEME.colors.warning.light,
		border: `1px solid ${THEME.colors.warning.main}`,
		borderRadius: THEME.common.borderRadius,
		display: 'flex',
		flexWrap: 'wrap',
		gap: THEME.spacing.sm,
		marginTop: THEME.spacing.md,
		padding: THEME.spacing.sm,
	},
	reconnectText: {
		color: THEME.colors.text.main,
		flex: 1,
		fontSize: THEME.typography.fontSizes.sm,
		minWidth: 180,
	},
	gmailHint: {
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.xs,
		marginTop: THEME.spacing.xs,
	},
	disclaimer: {
		backgroundColor: THEME.colors.background.main,
		borderRadius: THEME.common.borderRadius,
		color: THEME.colors.text.main,
		fontSize: THEME.typography.fontSizes.xs,
		lineHeight: 1.4,
		marginTop: THEME.spacing.xs,
		maxWidth: sectionContentWidth,
		// Matches the padding of the other settings help boxes (e.g. Business Hours).
		padding: 12,
	},
	verifyStatus: {
		alignItems: 'center',
		display: 'flex',
		flexWrap: 'wrap',
		fontSize: THEME.typography.fontSizes.sm,
		gap: THEME.spacing.xs,
		marginTop: THEME.spacing.sm,
		maxWidth: sectionContentWidth,
	},
	verifyValidating: {
		color: THEME.colors.text.light,
	},
	verifySuccess: {
		color: THEME.colors.success.dark,
	},
	verifyError: {
		color: THEME.colors.danger.main,
	},
});
